import status from '$mixins/status/component';
import handle from './handle';
import on from './on';

export default [status,handle,on];
